<template>
  <billing-report-panel
    report-key="guides-expired"
    route="/reports/billing-guides-expired"
    file-name="guias-fora-do-prazo.xlsx"
    period-label="Período do atendimento"
    :columns="columns"
    :default-days="360"
  />
</template>

<script>
import BillingReportPanel from './BillingReportPanel.vue';

export default {
  components: {
    BillingReportPanel,
  },
  data() {
    return {
      columns: [
        'Convênio e plano',
        'Guia',
        'Paciente',
        'Profissional',
        'Data do atendimento',
        'Prazo do plano em dias',
        'Venceu em',
        'Dias de atraso',
        'Valor em risco',
      ],
    };
  },
};
</script>
